[
  {
    "id": "4cc16059-e8c2-4e22-b618-c5ee09fe45e2",
    "scanDate": "2024-12-01T12:00:00Z",
    "floor": 1
  }
]